// eslint-disable-next-line max-classes-per-file
import { LocalDateTime } from '@js-joda/core'
import { RealTimeSearchHighlights } from '~app/features/real-time-playback/smart/real-time-stt/shared/RealTimeSttRemarkWithMetadata'
import { RealTimeSttTranscriptDividerData } from '~app/features/real-time-playback/smart/real-time-stt/shared/RealTimeSttTranscriptDivider'
import { RealTimePlaybackKey } from '~store/real-time-playback/real-time-playback-shared.model'
import { RealTimeSttAction } from '~store/real-time-stt/real-time-stt.actions'

export class RealTimeSttSetSearchHighlightsCommand {
  static readonly type = '[RealTimeStt] Set Search Highlights'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly searchHighlights: RealTimeSearchHighlights,
  ) {}
}

export class SetRealTimeSttCurrentPlaybackTimeCommand implements RealTimeSttAction {
  static readonly type = '[RealTimeStt] Set Real Time Stt Current Playback Time'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly currentPlaybackTime: LocalDateTime,
  ) {}
}

export class SetRealTimeSttTranscriptDividersCommand implements RealTimeSttAction {
  static readonly type = '[RealTimeStt] Set Real Time Stt Transcript Dividers'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly dividers: RealTimeSttTranscriptDividerData[],
  ) {}
}
